import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class XmlService
{
  /**
   * Get the CCDA xslt.
   */
  public getTransformedHtml(xsltDocument: Document, xmlContent: string): string
  {
    // Initializations
    const xsltProcessor = new XSLTProcessor();
    const parser = new DOMParser();

    // Parse core string retrieved from the server to formal XML document
    const xmlDocument = parser.parseFromString(xmlContent, 'text/xml');

    // Load stylesheet, transform to html
    xsltProcessor.importStylesheet(xsltDocument);
    const htmlDoc = xsltProcessor.transformToDocument(xmlDocument);
    return new XMLSerializer().serializeToString(htmlDoc);
  }
}
